import type { Metadata } from "next";
import Payment from "@/Component/Payment";

export const metadata: Metadata = {
    title: "Payment | Connector Club",
};

const PaymentPage = () => {
  return (
    <Payment />
  )
}

export default PaymentPage
